/** Shared flag: Away was set by idle auto-away (vs manual Away). */

const STORAGE_KEY = "circa.autoAwayActive";

let autoAwayActive = false;

try {
  autoAwayActive = localStorage.getItem(STORAGE_KEY) === "1";
} catch {
  autoAwayActive = false;
}

export const AUTO_AWAY_IDLE_MS = 5 * 60 * 1000;
/** Coalesce activity resets so high-frequency events don't thrash the timer. */
export const AUTO_AWAY_ACTIVITY_THROTTLE_MS = 1000;

function persist(value) {
  autoAwayActive = Boolean(value);
  try {
    if (autoAwayActive) {
      localStorage.setItem(STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function isAutoAwayActive() {
  return autoAwayActive;
}

export function setAutoAwayActive(value) {
  persist(value);
}

/** Call when the user intentionally changes presence (sidebar menu). */
export function clearAutoAwayActive() {
  persist(false);
}
